import { render, staticRenderFns } from "./car-archive.vue?vue&type=template&id=2c3474b3&scoped=true&"
import script from "./car-archive.vue?vue&type=script&lang=js&"
export * from "./car-archive.vue?vue&type=script&lang=js&"
import style0 from "./car-archive.vue?vue&type=style&index=0&id=2c3474b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3474b3",
  null
  
)

export default component.exports